import { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import DailySeancesSingleCinema from 'app/containers/Seances/DailySeancesSingleCinemaContainer';
import { DailySeancesSeveralCinemasProps } from 'app/containers/Seances/DailySeancesSeveralCinemasContainer';
import NoSeances from 'app/components/NoSeancesComponent';
import { NoSeancesReason } from 'app/types/seances';

const DailySeancesSeveralCinemasComponent = ({cinemasWithSeances, history}: DailySeancesSeveralCinemasProps) => {
	const handleClick = useCallback((id) => {
		history.push(`cinemas/${id}/contacts`);
	}, []);

	return (
		<div className="container">
			{!cinemasWithSeances.length && <NoSeances type={NoSeancesReason.NO_SEANCES_FOR_SELECTED_CINEMA}/>}
			{cinemasWithSeances.map((cinema) => (
					<div className="daily-seances-cinema" key={cinema.id}>
						<div className="daily-seances-cinema__label-wrapper" onClick={() => handleClick(cinema.id)}>
							<img className="daily-seances-cinema__pin" src="/img/mappin.svg" alt="cinema icon" />
							<div className="daily-seances-cinema__label">
								<div className="daily-seances-cinema__title">
									{cinema.title}
								</div>
								<div className="daily-seances-cinema__address">
									{cinema.address}
								</div>
							</div>
						</div>
						<div className="daily-seances-cinema__list">
							<DailySeancesSingleCinema
								seances={cinema.seances}
							/>
						</div>
					</div>
				)
			)}
		</div>
	);
};

export default withRouter(DailySeancesSeveralCinemasComponent);
